module.exports = __webpack_public_path__ + "static/media/4.a0c7cc15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/carousel/4.jpg
// module id = 661
// module chunks = 6